import transform from "css-to-react-native-transform";
import _ from "lodash";
import React from "react";

import TaskFieldCheckbox from "./taskFieldCheckbox";
import TaskFieldCheckList from "./taskFieldCheckList";
import TaskFieldDocumentViewer from "./taskFieldDocumentViewer";
import TaskFieldHidden from "./taskFieldHidden";
import TaskFieldImage from "./taskFieldImage";
import TaskFieldInput from "./taskFieldInput";
import TaskFieldInputNumber from "./taskFieldInputNumber";
import TaskFieldMinute from "./taskFieldMinute";
import TaskFieldMultiDocsUpload from "./taskFieldMultDocsUpload";
import TaskFieldMultipleUploadRequired from "./taskFieldMultipleUploadRequired";
import TaskFieldSelect from "./taskFieldSelect";
import TaskFieldTypography from "./taskFieldTypography";
import GridTable from "./taskFormGridTable";
import TaskStepper from "./taskStepper";
import {
  STEPPER,
  GRID,
  TYPOGRAPHY,
  IMAGE,
  NUMBER,
  MULTDOCSUPLOAD,
  MULTIPLEUPLOADREQUIRED,
  OPTIONLIST,
  CHECKBOX,
  CHECKBOXLIST,
  MINUTE,
  DOCUMENTVIEWER,
} from "../../../../../smartForms/components/constants";
import { havePermissionByPropertie } from "../../functions";

const TaskField = (props) => {
  const getUnitPropertie = (fieldProperties, constraintId) => {
    let model =
      fieldProperties &&
      _.find(fieldProperties.properties, function (a) {
        return a.id === constraintId;
      });
    model = model && model.value;
    return model;
  };

  const getField = () => {
    const { fieldProperties, isPreview, userPermission, login } = props;

    const type =
      typeof fieldProperties.type === "object"
        ? fieldProperties.type.name
        : fieldProperties.type;

    const toolTip = getUnitPropertie(fieldProperties, "toolTip");
    const multiLine = getUnitPropertie(fieldProperties, "multiLine");
    const rows = getUnitPropertie(fieldProperties, "rows");
    const columns = getUnitPropertie(fieldProperties, "columns");
    const id = fieldProperties && fieldProperties.id;
    const label = getUnitPropertie(fieldProperties, "label");
    let readOnly = getUnitPropertie(fieldProperties, "readOnly");
    const fullWidth = getUnitPropertie(fieldProperties, "fullWidth");
    const color = getUnitPropertie(fieldProperties, "color");
    let style = getUnitPropertie(fieldProperties, "propertieCSS");
    let isHidden = getUnitPropertie(fieldProperties, "hidden");
    const variant = getUnitPropertie(fieldProperties, "variant");
    const editAuth = getUnitPropertie(fieldProperties, "editAuth");
    const viewAuth = getUnitPropertie(fieldProperties, "viewAuth");

    const edit = getAuthorizationForUser("editAuth");
    const view = getAuthorizationForUser("viewAuth");

    function getAuthorizationForUser(type) {
      if (login && type) {
        const v =
          type === "editAuth"
            ? havePermissionByPropertie(editAuth, userPermission, login)
            : havePermissionByPropertie(viewAuth, userPermission, login);
        return v;
      }
      return false;
    }

    function readOnlyPermission() {
      if (!readOnly) {
        // SE O CAMPO NÃO FOR READ ONLY E O USUÁRIO NÃO POSSUIR PERMISSÃO

        if (
          (editAuth && editAuth.length > 0) ||
          (viewAuth && viewAuth.length > 0)
        ) {
          const hasEditAuth = !edit; // SE O USUÁRIO POSSUIR PERMISSÃO O CAMPO NÃO É READ ONLY

          return hasEditAuth;
        }
      } else {
        // SE HOUVER A PROPRIEDADE READ ONLY É RETORNADO TRUE
        return true;
      }
    }

    function viewOnlyPermission() {
      if (!isHidden && login) {
        if (
          (viewAuth && viewAuth.length > 0) ||
          (editAuth && editAuth.length > 0)
        ) {
          const hasViewAuth = !!view;
          const hasEditAuth = !!edit;

          const v = !(hasEditAuth || hasViewAuth);

          return v;
        }
      } else {
        return isHidden;
      }
    }

    readOnly = readOnlyPermission();
    isHidden = viewOnlyPermission();

    try {
      style = style ? transform(`      .value {` + style + "}").value : {};
    } catch {
      style = {};
    }

    const size = getUnitPropertie(fieldProperties, "size");

    if (isHidden) return <TaskFieldHidden {...props} id={id} label={label} />;

    switch (type) {
      case CHECKBOX:
        return (
          <TaskFieldCheckbox
            {...props}
            id={id}
            style={style}
            label={label}
            toolTip={toolTip}
            readOnly={readOnly}
            size={size}
          />
        );
      case OPTIONLIST:
        return (
          <TaskFieldSelect
            {...props}
            id={id}
            label={label}
            toolTip={toolTip}
            fullWidth={fullWidth}
            readOnly={readOnly}
            style={style}
          />
        );
      case TYPOGRAPHY:
        return (
          <TaskFieldTypography
            id={id}
            {...props}
            color={color}
            label={label}
            variant={variant}
            toolTip={toolTip}
            readOnly={readOnly}
            style={style}
          />
        );
      case IMAGE:
        return (
          <TaskFieldImage
            {...props}
            id={id}
            label={label}
            toolTip={toolTip}
            style={style}
          />
        );

      case CHECKBOXLIST:
        return (
          <TaskFieldCheckList
            {...props}
            id={id}
            size={size}
            toolTip={toolTip}
            readOnly={readOnly}
            style={style}
          />
        );
      case STEPPER:
        return (
          <TaskStepper
            {...props}
            id={id}
            label={label}
            toolTip={toolTip}
            fullWidth={fullWidth}
            readOnly={readOnly}
            style={style}
          />
        );
      case GRID:
        return (
          <GridTable {...props} rows={rows} columns={columns} style={style} />
        );
      case NUMBER:
        return (
          <TaskFieldInputNumber
            {...props}
            id={id}
            label={label}
            fullWidth={fullWidth}
            toolTip={toolTip}
            readOnly={readOnly}
            style={style}
          />
        );
      case MINUTE:
        return (
          <TaskFieldMinute
            {...props}
            id={id}
            label={label}
            isPreview={isPreview}
          />
        );

      case MULTDOCSUPLOAD:
        return (
          <TaskFieldMultiDocsUpload
            {...props}
            id={id}
            label={label}
            toolTip={toolTip}
          />
        );

      case MULTIPLEUPLOADREQUIRED:
        return (
          <TaskFieldMultipleUploadRequired
            {...props}
            id={id}
            label={label}
            toolTip={toolTip}
          />
        );

      case DOCUMENTVIEWER:
        return (
          <TaskFieldDocumentViewer
            title={id}
            isPreview={isPreview}
            {...props}
          />
        );

      default:
        return (
          <TaskFieldInput
            {...props}
            id={id}
            label={label}
            toolTip={toolTip}
            multiLine={multiLine}
            rows={rows}
            readOnly={readOnly}
            fullWidth={fullWidth}
            style={style}
          />
        );
    }
  };

  return (
    <div style={{ marginTop: "3%", marginBottom: "3%" }}>{getField()}</div>
  );
};

export default TaskField; //withRouter()
